// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"48":"f7eba087","421":"d8e57b33","437":"9a7c9c4e","534":"75b6b943","938":"f1381948"}[chunkId] + ".css";
};